{
  "version": 1,
  "asset_id": "1e2018b6-bb9a-4112-9df8-7d723a33ca75",
  "project_id": "288ffafd-b4ec-4687-a58e-f3a6c56e4541",
  "url": "/__l5e/assets-v1/1e2018b6-bb9a-4112-9df8-7d723a33ca75/senioren-seal-full.jpg",
  "r2_key": "a/v1/288ffafd-b4ec-4687-a58e-f3a6c56e4541/1e2018b6-bb9a-4112-9df8-7d723a33ca75/senioren-seal-full.jpg",
  "original_filename": "senioren-seal-full.jpg",
  "size": 1560152,
  "content_type": "image/png",
  "created_at": "2026-08-31T21:09:23Z"
}
